import React, { useState } from "react";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import EmployeeScoresList from "../EmployeeScoresList";
import IngestionStatusBanner from "../IngestionStatusBanner";
import Container from "../Container";
import Page from "../Page";
import { User } from "../../modules/users/types";
import { formatLongDate } from "@/utils/formatDate";

interface DashboardPageProps {
  user: User;
}

const DashboardPage: React.FunctionComponent<DashboardPageProps> = () => {
  const [hasScores, setHasScores] = useState(false);

  const today = formatLongDate();

  return (
    <Page>
      <Container>
        <Heading level={1} variant="lg">Latest Employee Scores</Heading>
        <Text variant="xl" className="text-muted-foreground mb-6">{today}</Text>
        {!hasScores && (
          <div className="mb-4">
            <IngestionStatusBanner />
          </div>
        )}
        <EmployeeScoresList onScoresLoaded={setHasScores} />
      </Container>
    </Page>
  );
};

export default DashboardPage;
